import HomeAlertMessage from './HomeAlertMessage';

export default HomeAlertMessage;
